export const API_PRODUCT = "https://670538b5031fd46a830f2457.mockapi.io/api/sport/product";
export const API_NEWS = "https://670872c48e86a8d9e42ef07f.mockapi.io/api/sport/news";
